import useExamPendenciesFilter from '@/data/hook/useExamPendenciesFilter';
import useListService from '@/data/hook/useListService';
import { studentExamQueries } from '@/data/query-keys/studentExamQueryKey';
import { REQUEST_STALE_TIME_IN_MS as staleTime } from '@/constants';
import ExamPendenciesTable from '@/components/shared/pendencies/tables/ExamPendenciesTable';

import User from '@/models/User';
import { SmartTableClassNames } from '@/components/ui/daisy/templates/smart-table/types';

type ExamsDashboardTabProps = {
  user: User;
  tableClassNames: SmartTableClassNames;
  tableClassName: string;
  emptyMessage?: string;
  pageSize?: number;
};

export function ExamsDashboardTab({
  user,
  tableClassNames,
  tableClassName,
  emptyMessage,
  pageSize,
}: ExamsDashboardTabProps) {
  const examsFilters = useExamPendenciesFilter();

  const examQuery = studentExamQueries.list({
    ...examsFilters.filters,
    pageSize: pageSize ?? 6,
  });

  const {
    results: pendingExams,
    isInitialLoading,
    error,
  } = useListService({
    queryKey: examQuery.queryKey,
    queryFn: examQuery.queryFn,
    enabled: !!user,
    keepPreviousData: true,
    staleTime,
  });

  return (
    <ExamPendenciesTable
      ordering={examsFilters.filters.ordering}
      onToggleOrdering={examsFilters.toggleOrdering}
      data={pendingExams}
      isLoading={isInitialLoading}
      error={error}
      emptyMessage={emptyMessage}
      classNames={tableClassNames}
      className={tableClassName}
    />
  );
}
